import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { useIncomingCallNotificationsEnabled } from '@/hooks/use-incoming-call-notifications-enabled';

const NotificationPermissionBanner = () => {
  const notificationsEnabled = useIncomingCallNotificationsEnabled();
  const { t } = useTranslation('notification-permission');

  if (notificationsEnabled) return null;

  const onEnable = () => {
    // No noopener/noreferrer: window.opener must stay linked so
    // enable-notifications.html can postMessage back once permission is
    // granted (see useIncomingCallNotificationsEnabled).
    window.open(`${window.location.origin}/enable-notifications.html`, '_blank');
  };

  return (
    <div className="flex items-center justify-between gap-2 border-b border-[#c8c8c8] bg-amber-50 px-3 py-1.5">
      <p className="text-xs text-amber-900">
        {t('Ative as notificações para saber quando uma chamada chegar com a aba em segundo plano')}
      </p>
      <Button
        size="sm"
        className="h-7 shrink-0 bg-amber-600 px-3 text-xs hover:bg-amber-700"
        onClick={onEnable}
      >
        {t('Ativar notificações')}
      </Button>
    </div>
  );
};

export default NotificationPermissionBanner;
